import ContentLoader, { Circle } from "react-content-loader/native";
import React from "react";

/* Adjust the width and height to set the size of the loader */
/* Use the style prop for margin/padding */

type Props = {
  width?: string | number;
  height?: string | number;
  style?: {};
};

const CircleLoader: React.FC<Props> = ({ width = 40, height = 30, style }) => {
  return (
    <ContentLoader
      speed={2}
      width={width}
      height={height}
      backgroundColor="#e8e8eb"
      foregroundColor="#aeaeb2"
      style={style}
    >
      <Circle cx="15" cy="15" r="15" />
    </ContentLoader>
  );
};

export default CircleLoader;
